import {
  AccountOutlined,
  LocationOutlined,
  UnionPaymentOutlined,
  NotificationsOutlined,
  OrderOutlined,
} from '@teko/ds-icon';
import { NavItem } from 'types';

export const SHARED_NAV_ITEMS: NavItem[] = [
  {
    icon: <AccountOutlined size={18} />,
    text: 'Thông tin tài khoản',
    href: '/account',
    contentName: 'viewAccountInfo',
    regionName: 'headerBar',
  },
  {
    icon: <OrderOutlined size={18} />,
    text: 'Quản lý đơn hàng',
    href: '/account/orders',
    contentName: 'viewOrder',
    regionName: 'headerBar',
  },
  {
    icon: <LocationOutlined size={18} />,
    text: 'Sổ địa chỉ',
    href: '/account/addresses',
    contentName: 'viewAddressList',
    regionName: 'headerBar',
  },
  {
    icon: <NotificationsOutlined size={18} className="noti" />,
    text: 'Thông báo',
    href: '/notification',
    anonymous: true,
    showByConfiguration: true,
    contentName: 'viewNotification',
    regionName: 'headerBar',
  },
  {
    icon: <UnionPaymentOutlined size={18} />,
    text: 'Điểm thành viên',
    href: '/my/loyalty-history',
    contentName: 'viewLoyalty',
    regionName: 'headerBar',
  },
];
